import React from 'react'
import './style.css'
//import axios from "axios"
import CodeModal from "../CodeModal/CodeModal";
import Button from "components/CustomButtons/Button.jsx";

/* eslint-disable */

const test = [
    {
        "term": "dance",
        "weight": 51.219444274902344
    },
    {
        "term": "sculpture",
        "weight": 51.004638671875
    },
    {
        "term": "choir",
        "weight": 47.05638122558594
    },
    {
        "term": "photography",
        "weight": 45.70722198486328
    },
    {
        "term": "theater",
        "weight": 44.4053840637207
    },
    {
        "term": "museum",
        "weight": 44.094852447509766
    },
    {
        "term": "arts",
        "weight": 43.528194427490234
    },
    {
        "term": "opera",
        "weight": 43.340248107910156
    },
    {
        "term": "music",
        "weight": 43.29771423339844
    },
    {
        "term": "artist",
        "weight": 42.81747817993164
    }
]

class CodeCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isDeleted: false,
            isAccepted: false,
            isDeclined: false,
            isModalOpen: false,
        }
        this.deleteCard = this.deleteCard.bind(this);
        this.acceptCard = this.acceptCard.bind(this)
        this.declineCard = this.declineCard.bind(this);
        this.codeDescription = this.codeDescription.bind(this);
        this.handleModelOpen = this.handleModelOpen.bind(this);
    }

    deleteCard(event) {
        event.stopPropagation()
        this.setState({isDeleted: true})
    }

    acceptCard(event) {
        event.stopPropagation()
        this.setState({isAccepted: !this.state.isAccepted, isDeclined: false})
    }

    declineCard(event) {
        event.stopPropagation()
        this.setState({isDeclined: !this.state.isDeclined, isAccepted: false})
    }

    handleModelOpen() {
        this.setState({isModalOpen: !this.state.isModalOpen});
    }

   async codeDescription(event) {
        const shortCodeIndex = this.props.code.split("").reverse().findIndex(e => e !== '0');
        const shortCode = this.props.code.split("").reverse().splice(shortCodeIndex).reverse().join("");
       // await axios.get("https://auto-coding-api.foundationcenter.org/top_vocabulary", {
        //    headers: {'x-api-key': `6FEFzchjsH49MST8pai1q8ggDxY4kqCC44Fgcs1e`},
         //   params: {label: `${shortCode}`}
       // }).then(res => console.log(res)).catch(error => console.log(`error text: ${error}`));
    }


    render() {
        return (
            <div className='code-card' style={{
                display: this.state.isDeleted ? 'none' : 'flex',
                color: this.state.isAccepted ? 'green' : this.state.isDeclined ? 'red' : "inherit"
            }} onClick={event => event.stopPropagation()}>
                <span>{this.props.description}</span>
                <span className={'full-code'} onClick={this.handleModelOpen}>{this.props.code}</span>
                {this.props.isControlRequired ?
                    <div className={'buttons'}>
                        <CodeModal open={this.state.isModalOpen} setClose={this.handleModelOpen} vocabulary={test}/>
                            <Button 
                                size="sm" 
                                color="primary"
                                className={'button'} 
                                onClick={this.acceptCard}
                            >
                                Accept
                            </Button> 
                            <Button 
                                size="sm" 
                                color="primary"
                                className={'button'} 
                                onClick={this.declineCard}
                            >
                                Decline
                            </Button> 
                            <Button 
                                size="sm" 
                                color="primary"
                                className={'button'} 
                                onClick={this.deleteCard}
                            >
                                Delete
                            </Button> 
                    </div> : null
                }
            </div>
        )
    }
}

export default CodeCard;


// WEBPACK FOOTER //
// ./src/components/CodeCard/CodeCard.jsx